module.exports = __webpack_public_path__ + "img/ic_notify_red.a5283aa6.svg";